import React from "react";
import UrlEditor from "../editors/urlEditor";

export default class UrlField extends React.Component {
    render() {
        let filter = null;

        const urlField = Object.keys(this.props.componentConfig.fielddefs || {}).find((field) => {
            return this.props.componentConfig.fielddefs[field].object === "url"
        });
        let valueKey = this.props.componentConfig.idfield;
        if (urlField) {
            valueKey = this.props.componentConfig.fielddefs[urlField].boundfield || valueKey;
        }

        if (this.props.values[valueKey]) {
            filter = [
                {field: "component_type", value: this.props.componentConfig.componentname},
                {field: "component_id", value: this.props.values[valueKey]},
            ];
        }
        return (
            <UrlEditor
                generate={!!this.props.componentConfig.url}
                filter={filter}
                presets={{
                    component_type: this.props.componentConfig.componentname,
                    component_id: this.props.values[this.props.componentConfig.idfield],
                }}
                isLoading={this.props.isLoading}
                selection={null}
            />
        );
    }
}